import { motion } from "framer-motion";

const categoryLabels = {
  Energy: "Energy",
  Aviation: "Aviation Capital",
  "Carbon Credits": "Carbon Markets",
};

export const ProjectCard = ({ project, index = 0, onClick }) => {
  const funded = (project.status || "").toLowerCase() === "funded";
  return (
    <motion.button
      type="button"
      data-testid={`project-card-${project.id}`}
      onClick={onClick}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08 }}
      className="group relative text-left w-full overflow-hidden rounded-sm border border-white/10 bg-sp-darksurface hover:border-white/25 transition-colors duration-500"
    >
      <div className="relative h-56 overflow-hidden">
        {project.image_url ? (
          <img
            src={project.image_url}
            alt={project.title}
            className="h-full w-full object-cover opacity-80 transition-transform duration-[1.2s] ease-out group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-sp-navy/30" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-sp-dark via-sp-dark/30 to-transparent" />

        {funded && (
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <span
              data-testid={`project-funded-watermark-${project.id}`}
              className="select-none font-serif text-4xl md:text-5xl uppercase tracking-[0.25em] text-white/15 border-y-2 border-white/15 px-6 py-2"
              style={{ transform: "rotate(-14deg)" }}
            >
              Funded
            </span>
          </div>
        )}

        <span className="absolute top-4 left-4 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/70 bg-black/30 backdrop-blur px-3 py-1 rounded-full">
          {categoryLabels[project.category] || project.category}
        </span>
      </div>

      <div className="p-7">
        <div className="flex items-center justify-between gap-3">
          <h3 className="font-serif text-2xl text-white leading-tight">{project.title}</h3>
        </div>
        <p className="mt-1 font-mono text-xs uppercase tracking-[0.15em] text-sky-300/70">
          {project.location}
        </p>
        <p className="mt-4 font-sans text-sm leading-relaxed text-white/60 line-clamp-3">
          {project.summary}
        </p>
        <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-4">
          <div>
            <p className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-white/40">Capital</p>
            <p className="font-sans text-sm font-semibold text-white/90">{project.capital || "—"}</p>
          </div>
          <span
            className={`font-mono text-[0.65rem] uppercase tracking-[0.18em] px-3 py-1 rounded-full ${
              funded
                ? "text-emerald-300 bg-emerald-400/10 border border-emerald-400/20"
                : "text-amber-200 bg-amber-300/10 border border-amber-300/20"
            }`}
          >
            {funded ? "Funded" : "Active"}
          </span>
        </div>
      </div>
    </motion.button>
  );
};

export default ProjectCard;
